module.exports = __webpack_public_path__ + "img/riskheader.69ba8047.png";